import { FunctionComponent } from "react";
import Modal from "../../../../../../common/Modal/Modal";
import Label from "../../../../../../Label";
import { Icon } from "../../../../../../Icon";
import "./styles.scss";
import Button from "../../../../../../common/Button";
import { useCart } from "../../../../../../../context/CartContext";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};
const ClearCartModal: FunctionComponent<Props> = ({ isOpen, onClose }) => {
  const { clearCart } = useCart();

  const handleOnDelete = () => {
    clearCart();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      children={
        <div className="remove-item-modal">
          <header className="remove-item-modal__header">
            <Label tag="h3" className="remove-item-modal__title">
              Limpiar carrito
            </Label>
            <div onClick={onClose}>
              <Icon
                iconName="close_icon"
                className="remove-item-modal__close-icon"
              />
            </div>
          </header>
          <div className="remove-item-modal__content">
            <div className="remove-item-modal__details">
              <Label
                tag="p"
                variants="body1"
                className="remove-item-modal__details__description"
              >
                ¿Estás seguro de borrar todos los productos?
              </Label>
            </div>
            <div className="remove-item-modal__buttons">
              <Button
                applyNewSize
                modifier="tertiary"
                className="remove-item-modal__button--cancel"
                onClick={onClose}
              >
                Cancelar
              </Button>
              <Button
                applyNewSize
                className="remove-item-modal__button--delete"
                onClick={handleOnDelete}
                modifier="fifth"
              >
                Si
              </Button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ClearCartModal;
